// src/services/macroMarketService.ts
// Service macro marché : dominance BTC/ETH avec cache mémoire 30min

export interface MacroMarketData {
  btcDominance: number;
  ethDominance: number;
  lastUpdated: number;
}

let cache: MacroMarketData | null = null;
const TTL = 1800000; // 30 minutes en ms

export async function getMacroMarketData(): Promise<MacroMarketData | null> {
  const now = Date.now();
  if (cache && now - cache.lastUpdated < TTL) {
    return cache;
  }
  try {
    const res = await fetch('https://api.coingecko.com/api/v3/global');
    if (!res.ok) throw new Error('API CoinGecko indisponible');
    const json = await res.json();
    cache = {
      btcDominance: json.data.market_cap_percentage.btc,
      ethDominance: json.data.market_cap_percentage.eth,
      lastUpdated: now
    };
    return cache;
  } catch (error) {
    // Fallback : retourne dernière valeur si dispo
    return cache || null;
  }
}
